import {Component, inject, Inject, OnInit, ViewChild} from '@angular/core';
import {Carousel, CarouselModule} from "primeng/carousel";
import {ButtonDirective} from "primeng/button";
import {OptionCarousel} from "../../../../shared/interfaces/sede_electronica";
import {NgOptimizedImage} from "@angular/common";
import {Router} from "@angular/router";

@Component({
    selector: 'app-carrousel-gov-co',
    standalone: true,
    imports: [
        CarouselModule,
        ButtonDirective,
        NgOptimizedImage
    ],
    template: `
        <p-carousel (onPage)="changePage($event)"
                circular=true [value]="options" verticalViewPortHeight="248px"
                styleClass="mb-2" [responsiveOptions]="responsiveOptions">
            <ng-template pTemplate="item" let-item>
                <div class="relative">
                    @if (isArray(item.images)) {
                        <picture>
                            @for (img of item.images; track img) {
                                @if (img.default) {
                                    <img [src]="img.src" [alt]="img.alt" draggable="false"
                                         [ngClass]="img.class" [ngStyle]="img.ngStyle"
                                         class="w-full">
                                } @else {
                                    <source [srcset]="img.src" [media]="img.media">
                                }
                            }
                        </picture>
                    } @else {
                        <img [src]="item.images.src" [alt]="item.images.alt" draggable="false"
                             [ngClass]="item.images.class" [ngStyle]="item.images.ngStyle"
                             class="w-full">
                    }

                    <div class="text-left absolute z-5  container-text">
                        <h3 class="my-0 text-white font-bold animated-text">{{ item.title }}</h3>
                        <p class="text-white pt-0 mt-2 animated-text">{{ item.description }}</p>
                        <button pButton [label]="item.button.label" [class]="item.button.class" class="button-action animated-text"
                                [icon]="item.button.icon" iconPos="right"
                                (click)="item.button.onClick ? item.button.onClick($event): null"></button>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <div class="relative width-container mx-auto">
                    <a class="flex absolute align-items-center no-underline text-decoration-none
        control-play  cursor-pointer mt-2 md:mt-0 ml-3 md:ml-0" (click)="controlPlay()"
                       role="button" aria-label="Reproducir carrusel de imágenes">
                        @if (!autoPlay) {
                            <img ngSrc="assets/img/svg/play.svg" alt="control play" draggable="false" height="17"
                                 width="19">
                        }@else{
                            <i class="pi pi-pause animated-text font-20 text-blue-general bold"></i>
                        }

                        <span class="ml-3 text-blue-general font-16 animated-text">Reproducir</span>
                    </a>

                </div>
            </ng-template>
        </p-carousel>
    `,
    styleUrl: './carrousel-gov-co.component.scss'
})
export class CarrouselGovCoComponent implements OnInit {
    autoPlay: boolean = false;
    private readonly INTERVAL_AUTO_PLAY: number = 5_000;
    options: OptionCarousel[] = [];
    responsiveOptions: any[] = [];
  private readonly router: Router = inject(Router);

    ngOnInit(): void {
        this.initializeOptions();
        this.initOptions();
    }

    @ViewChild(Carousel) carousel!: Carousel;

    initializeOptions() {
        this.responsiveOptions = [
            {
                breakpoint: '1199px',
                numVisible: 1,
                numScroll: 1
            },
            {
                breakpoint: '991px',
                numVisible: 1,
                numScroll: 1
            },
            {
                breakpoint: '767px',
                numVisible: 1,
                numScroll: 1
            }
        ];
    }

    initOptions() {
        this.options = [
            {
                title: 'Consulta de Trámites y Servicios',
                description: 'Consulta ágil de los trámites disponibles en el Portal en Línea y los requisitos para cada uno de ellos.',
                images: [{
                    src: 'assets/img/icons-principal/gov-HeroBanner-Landing-Desktop_2x.webp',
                    alt: 'Trámites y servicios de la Gobernación del Magdalena',
                    media: '(width > 1367px)',
                }, {
                    src: 'assets/img/icons-principal/gov-HeroBanner-Landing-Desktop.webp',
                    alt: 'Trámites y servicios de la Gobernación del Magdalena',
                    media: '(width <= 1366px)',
                }, {
                    src: 'assets/img/icons-principal/gov-HeroBanner-Landing-Desktop.webp',
                    alt: 'Trámites y servicios de la Gobernación del Magdalena',
                    class: 'img-corousel',
                    default: true
                },
                ],
                button: {
                    label: 'Haga su consulta',
                    icon: 'pi pi-angle-right',
                    class: 'p-button-rounded',
                    onClick: (event) => {
                       this.router.navigateByUrl('/sede-electronica/consulta').then();
                    }
                }
            },
            {
                title: 'Canales de Atención al Ciudadano',
                description: 'Aproveche formas de comunicar eficientes y efectivas, acceda fácil y rápido a la información que necesite.',
                images: [{
                    src: 'assets/img/icons-principal/gov-HeroBanner-Landing-2-Canales_2x.webp',
                    alt: 'Canales de atención al ciudadano de la Gobernación del Magdalena',
                    media: '(width > 1367px)'
                },
                    {
                        src: 'assets/img/icons-principal/gov-HeroBanner-Landing-2-Canales.webp',
                        alt: 'Canales de atención al ciudadano de la Gobernación del Magdalena',
                        media: '(width <= 1366px)'
                    }, {
                        src: 'assets/img/icons-principal/gov-HeroBanner-Landing-2-Canales.webp',
                        alt: 'Canales de atención al ciudadano de la Gobernación del Magdalena',
                        class: 'img-corousel',
                        default: true
                    },],
                link: 'https://www.gov.co/atencion-al-ciudadano',
                button: {
                    label: 'Conoce los Canales',
                    icon: 'pi pi-angle-right',
                    class: '  p-button-rounded',
                    onClick: (event) => {
                      this.router.navigateByUrl('/sede-electronica/inicio').then();

                    }
                }
            }, {
                title: 'Atención a PQRSDF',
                description: 'Haga Peticiones, Quejas, Reclamos, Sugerencias, Denuncias y Felicite o Vea el avance de su proceso.',
                images: [{
                    src: 'assets/img/icons-principal/gov-HeroBanner-Landing-3-PQRSD_2x.webp',
                    alt: 'Atención al ciudadano de PQRSDF del Departamento del Magdalena',
                    media: '(width > 1367px)'
                }, {
                    src: 'assets/img/icons-principal/gov-HeroBanner-Landing-3-PQRSD.webp',
                    alt: 'Atención al ciudadano de PQRSDF del Departamento del Magdalena',
                    media: '(width <= 1366px)'
                }, {
                    src: 'assets/img/icons-principal/gov-HeroBanner-Landing-3-PQRSD.webp',
                    alt: 'Atención al ciudadano de PQRSDF del Departamento del Magdalena',
                    class: 'img-corousel',
                    default: true
                },],
                button: {
                    label: 'Vea todo sobre PQRSDF',
                    icon: 'pi pi-angle-right',
                    class: 'p-button-rounded',
                    onClick: () => {
                      this.router.navigateByUrl('/sede-electronica/pqrsd').then();
                    }
                }
            }
        ];
    }

    isArray(value: any): boolean {
        return Array.isArray(value);
    }

    controlPlay(autoPlay?:boolean) {
        if( autoPlay !== undefined) {
            this.autoPlay = autoPlay;
        }else{
            this.autoPlay =  !this.autoPlay;
        }

        if (this.autoPlay) {
            this.carousel.autoplayInterval = this.INTERVAL_AUTO_PLAY;
            this.carousel.startAutoplay();
        } else {
            this.carousel.autoplayInterval = 0;
            this.carousel.stopAutoplay();
        }
    }

  changePage(event: any) {

    if ((!this.carousel.allowAutoplay || !this.carousel.isAutoplay()) && this.autoPlay) {
      this.controlPlay(false);
    }

  }

}


